import { PackagePrice, ProductImageType } from "./GSDD";
import { DrugCategory } from "./DrugCategory";
import { VendorDrugMap } from "./VendorDrugMap";
import HasLabel from "./HasLabel";

export interface DrugStatus {
    packageID: number;
    status: number;
    disableAutorefill: boolean;
    autorefillMaxLength: number | null;
    updated: Date;
    updatedBy: string;
}
export class DrugStatus {
    constructor(obj?:DrugStatus){
        this.status = 0;
        this.disableAutorefill = false;
        this.autorefillMaxLength = null;
        
        if(obj) Object.assign(this, obj);
    }
}

export interface Drug {
    packageID?: string;
    productID: string;
    ndc: string;
    packageSize: number;
    billingUnit: string;
    productNameShort: string;
    productNameLong: string;
    marketer: string;
    doseForm: string;
    deaClass: string;
    brandGenericStatus: string;
    isOffMarket: boolean;
    isReplaced: boolean;
    packageDescription: string;
    therapeuticEquivalenceCode: string[];
    routeOfAdministration: string | null;

    productDetail: any; // GSDD DetailProductType
    packageDetail: any; // GSDD DetailPackageType
    prices: PackagePrice[]; // GSDD PriceDataType
    images: ProductImageType[];

    notes: DrugNote[];
    status: DrugStatus;

    categories?: DrugCategory[];
    vendors?: VendorDrugMap[];
}

export class Drug extends HasLabel {
    constructor(packageId?:string|number|null, obj?:Drug){
        super();
        this.packageID = packageId?.toString();
        this.status = new DrugStatus();

        if(obj){
            Object.assign(this, obj)
            this.status = new DrugStatus(obj.status);
        }
    }
    toString(): string {
        const productName = this.productNameLong || this.productNameShort;
        if(productName)
            return this.ndc ? `NDC:${this.ndc} - ${productName} ${this.packageSize ? ("- PS: " + this.packageSize) : ""}` 
            : productName;
            
        else return '';
    }
}

export namespace Drug {
    export class EquivalentDrug{
        packageID? : number;
        productID? : number;
        ndc? : string;
        brandGenericStatus? : string;
        productNameLong? : string;
        marketer? : string;
        packageSize?: number;
    }
}

export interface DrugNote {
    packageID: number;
    note: string;
    created: Date;
    createdBy: string;
}

export namespace DrugStatus {
    export enum DrugStatusEnum {
        Inactive,
        Active,
        ActiveAndPreferred,
        BlockedFromFills,
    }
}
